"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Favorite;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Favorite(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "favorite"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-4",
    "data-name": "outline",
    d: "M92.746,33.474c0-.023,0-.043,0-.058A24.8,24.8,0,0,0,67.975,8.645,24.524,24.524,0,0,0,50,16.41,24.526,24.526,0,0,0,32.024,8.645,24.8,24.8,0,0,0,7.253,33.416c0,.021,0,.042,0,.063-.1,2.007-.691,29.737,40.891,57.317l.071.056a2.5,2.5,0,0,0,1.506.5c.052,0,.1,0,.159,0,.028,0,.054-.015.082-.017a2.619,2.619,0,0,0,.279.021c.068,0,.136,0,.2-.008a2.524,2.524,0,0,0,1.293-.471l.058-.043C93.474,63.216,92.847,35.435,92.746,33.474ZM50,86.007C12.646,60.824,12.217,35.755,12.245,33.836a2.493,2.493,0,0,0,.015-.275c0-.067,0-.134-.007-.2a19.752,19.752,0,0,1,35.5-11.877A2.49,2.49,0,0,0,50,22.445a2.488,2.488,0,0,0,2.245-.966,19.752,19.752,0,0,1,35.5,11.881c0,.066-.007.155-.007.2a2.4,2.4,0,0,0,.015.269C87.783,35.793,87.322,60.844,50,86.007Z"
  }))));
}